document.addEventListener('click',function(e){const toggle=e.target.closest('[data-menu-toggle]');if(!toggle)return;const nav=document.querySelector('[data-mobile-menu]');if(nav){nav.hidden=!nav.hidden;toggle.setAttribute('aria-expanded',String(!nav.hidden));}});
(() => {
 const root = window.Shopify?.routes?.root || '/';
 const drawer = document.getElementById('CartDrawer');
 let trigger;
 async function openCart(button) {
  trigger=button;
  if (!drawer.open) drawer.showModal();
  const panel=drawer.querySelector('[data-cart-content]');
  const error=drawer.querySelector('[data-cart-error]');
  error.hidden=true; panel.setAttribute('aria-busy','true');
  try {
   const response=await fetch(root+'?section_id=cart-panel');
   if(!response.ok) throw new Error('Cart');
   panel.innerHTML=await response.text();
  } catch(e) {error.hidden=false;} finally {panel.removeAttribute('aria-busy');}
 }
 document.addEventListener('click',e=>{
  const link=e.target.closest('[data-open-cart]');
  if(link&&drawer&&!e.ctrlKey&&!e.metaKey){e.preventDefault();openCart(link);}
  if(e.target.closest('[data-close-cart]'))drawer?.close();
 });
 drawer?.addEventListener('close',()=>trigger?.focus());
 drawer?.addEventListener('click',e=>{if(e.target===drawer){const b=drawer.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)drawer.close();}});
 document.addEventListener('change',e=>{
  if(!e.target.matches('[data-variant-select]'))return;
  const option=e.target.selectedOptions[0];
  const price=document.querySelector('[data-product-price]');
  if(price)price.textContent=option.dataset.price;
  const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
 });
 document.addEventListener('submit',async e=>{
  const form=e.target;
  if(!drawer||!form.matches('form.product-form'))return;
  e.preventDefault();const button=form.querySelector('[type=submit]');button.disabled=true;
  let error=form.querySelector('[data-add-error]');
  if(!error){error=document.createElement('p');error.dataset.addError='';error.setAttribute('role','alert');form.append(error);}
  error.textContent='';
  try{
   const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
   const data=await response.json();if(!response.ok)throw new Error(data.description||'Bitte versuche es erneut.');
   const cartResponse=await fetch(root+'cart.js');if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);}
   await openCart(button);
  }catch(err){error.textContent=err.message;}finally{button.disabled=false;}
 });
 document.querySelectorAll('[data-recommendations]').forEach(async el=>{
  try{const response=await fetch(el.dataset.url);if(!response.ok)return;const html=new DOMParser().parseFromString(await response.text(),'text/html');const content=html.querySelector('[data-recommendation-content]');if(content)el.querySelector('[data-recommendation-content]').innerHTML=content.innerHTML;}catch(e){}
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){const nav=document.querySelector('[data-mobile-menu]');if(nav&&!nav.hidden){nav.hidden=true;const toggle=document.querySelector('[data-menu-toggle]');toggle?.setAttribute('aria-expanded','false');toggle?.focus();}}});
})();
